import { User } from "../../typings";

export const invalidName =
  "Input can only have spaces, letters, numbers, hyphens, '@', and periods.";

// Returns any potential errors in string form
export const checkValidName = (name: string) => {
  let regexp = /^[a-zA-Z0-9-@. ]+$/;
  let allErr = "";

  const appendErr = (newErr: string) => {
    if (allErr !== "") {
      allErr += " ";
      allErr += newErr;
    } else {
      allErr += newErr;
    }
  };

  if (name) {
    if (name.search(regexp) === -1) {
      appendErr(invalidName);
    }
  }

  return allErr === "" ? undefined : allErr;
};

export const getUserFullName = (user: User) =>
  user.firstName + " " + user.lastName;

export const displayUserInfo = (user: User) => {
  const fullName = getUserFullName(user);
  const id = user.username || (user as any).id;
  const idWithBraces = id ? `(${id})` : "";
  return `${fullName} ${idWithBraces}`;
};

export const parseUsername = (value: string) => {
  let username = "";
  const parts = value.trim().split(" ");
  if (parts.length >= 3) {
    const usernamePart = parts[parts.length - 1];
    if (
      usernamePart.length >= 2 &&
      usernamePart.charAt(0) === "(" &&
      usernamePart.charAt(usernamePart.length - 1) === ")"
    ) {
      username = usernamePart.substring(1, usernamePart.length - 1);
    }
  }
  return username;
};
